import * as React from 'react';

function PlaceholderScooterOdometer(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			id="mileage-placeholder-motorbike"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 550 350"
			shape-rendering="geometricPrecision"
			text-rendering="geometricPrecision"
			{...props}
		>
			<defs>
				<style>
					{
						'.F727D5C8-D16B-44F7-80F0-2C2E74C90CED{fill: var(--primary-color);} .EFC88498-EB53-4E5A-B1C8-A0829675A45C{fill: var(--primary-color); opacity:0.4;} .3573B8EC-9968-4D74-8CCA-FBB2ADC47F25{fill: var(--primary-color); opacity:0.5;} .376C75E5-B966-473E-9116-E17926F265BF{fill: var(--primary-color); opacity:0.1;}'
					}
				</style>
			</defs>
			<g
				id="mileage-placeholder-motorbike-original"
				transform="matrix(.091032 0 0-.098503 73.167113 407.882325)"
			>
				<g className="EFC88498-EB53-4E5A-B1C8-A0829675A45C" opacity="0.4">
					<ellipse
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						rx="180.910601"
						ry="64.256293"
						transform="matrix(10.420706 0 0 14.756555 2187.895924 2716.380537)"
						strokeWidth="0"
					/>
					<rect
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						width="427"
						height="182.059497"
						rx="52"
						ry="52"
						transform="matrix(8.830054 0 0-9.203661 304.736293 3034.565994)"
						strokeWidth="0"
					/>
				</g>
				<g className="3573B8EC-9968-4D74-8CCA-FBB2ADC47F25">
					<ellipse
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						rx="164.777221"
						ry="152.279626"
						transform="translate(2924.489406 1661.575198)"
						stroke="rgba(194,27,23,0.7)"
						strokeWidth="3"
					/>
					<ellipse
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						rx="164.777221"
						ry="152.279626"
						transform="translate(2436.218117 1661.575197)"
						stroke="rgba(194,27,23,0.7)"
						strokeWidth="3"
					/>
					<ellipse
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						rx="164.777221"
						ry="152.279626"
						transform="translate(1958.931972 1661.575201)"
						stroke="rgba(194,27,23,0.7)"
						strokeWidth="3"
					/>
					<ellipse
						className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
						rx="164.777221"
						ry="152.279626"
						transform="translate(1475.58546 1661.575201)"
						stroke="rgba(194,27,23,0.7)"
						strokeWidth="3"
					/>
				</g>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1135,3441c-254-69-452-254-532-498-38-114-44-296-14-413c24-95,74-200,132-277l39-52v-119c0-113,1-120,29-163c38-61,84-82,186-87l81-4-4-31c-2-25,17-70,85-196c74-137,94-167,123-183c34-17,75-18,1000-16l965,3l30,21c41,30,195,320,195,369v35h63c89,0,136,16,178,60c45,47,59,100,59,225c0,96,0,96,39,148c98,131,145,275,145,447c0,180-53,332-161,467-106,133-269,236-421,268-104,21-261,20-354-4-132-34-285-124-366-216l-40-45h-337-338l-72,69c-87,82-181,140-290,177-108,37-312,44-420,15Zm408-44c101-35,202-97,278-172c154-151,226-334,216-545-6-110-12-152-26-185-20-43-30-88-24-99c3-6,2-8-2-3-10,9-57-71-49-84c3-5,2-8-3-7-4,1-51-41-103-93-78-79-110-103-180-137-220-108-439-109-655-3-242,120-395,368-395,641c0,330,219,613,540,700c111,30,295,24,403-13Zm1813,13c259-65,463-269,529-530c22-86,22-255,0-341-63-244-237-431-481-516-72-25-92-27-219-27-126,0-148,2-220,27-44,14-109,43-145,64-91,53-226,191-270,275-19,36-39,64-44,61s-6-1-3,4c4,6,0,29-8,52-7,22-19,85-26,139-20,160,13,325,93,460c50,86,189,221,273,264c67,35,171,72,225,81c74,12,221,6,296-13Zm-798-268c-1-5-16-34-33-65l-30-57h-241-242l-36,61c-20,33-36,62-36,65c0,2,140,4,311,4s309-4,307-8Zm-83-169c-46-119-55-348-17-458c11-33,18-63,16-67-3-4-104-7-225-8h-220l6,38c4,20,12,51,18,67c7,18,12,86,11,175c0,118-4,156-21,208l-21,62h230c215,0,230-1,223-17Zm-53-561l67-2l31-59c97-182,282-323,488-372c120-29,291-23,407,15c90,29,186,82,252,140l45,39-4-111-3-111-35-36c-40-41-81-55-169-55-53,0-68,4-93,25l-30,25h-1119c-984,0-1124-2-1149-15-17-9-30-20-30-25c0-6-34-10-78-10-93,0-154,26-189,79-20,29-23,47-23,133v98l56-45c167-136,417-196,632-150c205,43,396,182,488,355l40,75l80,5c74,5,178,5,336,2Zm970-562c25-26,29-37,25-63-7-41-141-294-173-327l-24-25-954-3c-603-1-963,1-980,7-30,12-52,45-141,216l-67,131l15,36c8,20,23,41,34,47c12,7,357,10,1126,11h1109l30-30Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1202,3378c-80-12-205-64-269-112-301-222-379-610-184-919c57-90,160-184,256-234c111-58,188-76,315-76c192,0,338,61,476,198c83,82,155,200,138,226-4,7-3,10,4,5c14-9,48,107,57,195c14,134-33,308-114,427-153,223-409,333-679,290Zm281-44c167-43,326-169,404-320c23-43,46-98,52-121c41-152,28-330-31-448-93-183-222-295-413-355-54-17-94-22-175-22-115,0-196,20-301,72-234,118-378,397-339,656c59,389,426,636,803,538Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1336,3283c-10-66-7-113,8-113s33,120,21,140-22,10-29-27Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1190,3292c0-49,24-132,37-132c12,0,14,10,8,53-9,63-21,97-35,97-5,0-10-8-10-18Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1485,3278c-40-115-42-128-21-128c13,0,47,90,47,125c1,15-20,18-26,3Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1047,3254c-5-5,45-118,59-133c3-3,9,0,15,6c7,7,1,29-20,72-30,58-40,69-54,55Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1265,3249c-4-6-4-26-1-45c9-43,36-47,36-5c0,51-19,77-35,50Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1396,3228c-9-34-7-68,3-68c13,0,18,9,26,53c6,29,4,37-8,37-8,0-17-10-21-22Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1130,3220c0-6,7-27,15-47c11-26,19-33,26-26c15,15-7,83-27,83-8,0-14-5-14-10Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1595,3175c-37-57-41-70-25-80c10-6,80,97,80,120c0,29-21,14-55-40Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1515,3174c-18-45-18-44,0-44c14,0,45,48,45,70c0,25-31,7-45-26Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M920,3166c0-19,79-106,96-106c23,0,17,12-32,68-46,52-64,63-64,38Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1010,3158c0-20,47-74,56-65c11,11-26,77-43,77-7,0-13-6-13-12Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1632,3117c-22-24-30-57-13-57c13,0,51,50,51,66c0,20-14,17-38-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1698,3087c-47-43-60-67-35-67c13,0,107,90,107,103c0,17-29,3-72-36Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M910,3066c0-15,45-56,61-56c17,0,9,27-14,48-27,25-47,28-47,8Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M820,3057c0-18,90-87,114-87c28,0,17,17-35,55-63,45-79,52-79,32Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1716,3019c-28-22-34-39-12-39c19,0,67,40,61,51-9,14-20,11-49-12Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1781,2980c-67-37-67-38-53-52c8-8,26-2,68,23c53,31,68,50,47,56-4,1-32-11-62-27Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M830,2957c0-7,16-21,35-30c43-21,45-21,45-2c0,8-13,21-30,30-36,18-50,19-50,2Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M750,2917c0-7,28-23,63-35c73-26,77-26,77-8c0,7-25,23-56,35-64,24-84,26-84,8Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1766,2904c-21-12-25-19-17-27c9-9,16-8,31,1c11,6,27,12,35,12s15,7,15,15c0,19-27,19-64-1Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1828,2855c-58-16-70-23-62-37c12-18,144,16,144,37c0,17-18,17-82,0Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M780,2831c0-13,9-18,53-26c29-6,37-4,37,8c0,15-28,27-67,27-13,0-23-4-23-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1274,2831c-20-9-69-60-76-80-1-6-106-25-233-43l-230-33-3-27c-3-26-1-28,36-28c22,0,130,9,240,20l200,20l30-30c25-24,39-30,74-30c48,0,103,28,112,58c7,21,43,32,108,32c61,0,74,11,70,59-4,39-6,41-36,40-17,0-53-4-81-9-47-8-52-6-81,22-34,32-92,45-130,29Zm88-37c40-21,27-31-54-39-70-8-83-1-50,27c35,31,62,34,104,12Zm208-49c0-19,0-19-316-50-270-27-404-31-204-6c58,7,193,25,300,41c237,34,220,33,220,15Zm-193-90c-30-27-84-34-105-13s-13,27,41,31c28,2,61,4,72,5c17,1,16-2-8-23Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M714,2778c-11-18,10-26,75-30c45-2,66,1,68,9c6,16-7,20-79,26-34,3-60,1-64-5Z"
					transform="translate(-39.999999 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1781,2776c-11-13-11-17,2-21c19-8,76,7,80,20c4,17-68,18-82,1Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1780,2705c0-12,15-15,75-15s75,3,75,15-15,15-75,15-75-3-75-15Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1772,2648c5-13,74-29,83-20c3,3,5,11,5,19c0,9-14,13-46,13s-44-4-42-12Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1762,2588c5-14,53-32,113-44c56-10,41,17-21,38-60,20-97,23-92,6Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1745,2539c-4-6-5-12-3-14c11-11,76-33,82-28c13,13,5,25-29,39-41,17-42,17-50,3Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1716,2481c-7-10,3-19,66-54c52-30,68-33,68-14c0,12-99,77-118,77-6,0-13-4-16-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1024,2437c-3-8-4-45-2-83l3-69l63-3l63-3-3,83-3,83-58,3c-42,2-59-1-63-11Zm96-78v-50l-32,3c-18,2-32,6-30,11c1,4,2,25,2,47c0,38,2,40,30,40c29,0,30-1,30-51Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1187,2443c-4-3-7-42-7-85v-79l58,3l57,3l3,76l3,76-32,7c-41,8-74,8-82-1Zm83-78c0-54,0-55-30-55-29,0-30,1-30,49c0,46,2,50,28,54c15,2,28,5,30,6c1,0,2-24,2-54Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1334,2441c-2-2-4-40-4-83v-79l63,3l62,3v80v80h-58c-32,0-61-2-63-4Zm86-76c0-54,0-55-30-55s-30,1-30,55s0,55,30,55s30-1,30-55Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1523,2443l-33-4v-80-79h54h55l6,53c4,29,5,66,3,82-3,32-18,37-85,28Zm38-33c16,0,19-7,19-50v-50h-35-35v56c0,47,3,55,16,50c9-3,24-6,35-6Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M1690,2426c0-14,41-46,60-46c17,0,11,21-12,41-27,22-48,24-48,5Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3050,3375c-191-36-382-181-468-355-56-115-72-183-72-310c0-116,13-179,58-273c103-222,274-354,508-394c83-14,112-14,187-4c241,32,429,168,533,386c110,229,74,513-90,718-81,100-232,195-360,226-77,19-213,22-296,6Zm297-40c171-44,335-178,412-337c94-194,94-385,1-574-121-243-392-389-654-353-117,16-122,22-43,57c67,31,67,31,55,59-6,15-14,31-18,35-3,4-55-12-115-36l-110-43-47,29c-64,40-177,163-211,232-16,31-33,54-38,51-5-4-6,2-2,11c5,13,3,15-7,9-9-5-11-4-6,3c4,6,0,45-9,86-51,249,28,483,217,642c160,134,369,181,575,129ZM3074,2172c-24-21-137-63-145-55-6,6,20,21,68,40c73,29,99,34,77,15Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3207,3313c-3-5-6-37-8-73-3-53-1-65,11-65s16,16,18,73c2,42-1,72-7,72-5,0-12-3-14-7Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2946,3272c-7-11,28-108,46-130c23-27,27,6,7,58-23,61-43,88-53,72Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3135,3249c-11-18,5-79,20-79c16,0,19,28,9,68-7,24-19,29-29,11Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3257,3213c-4-21-2-42,3-47c14-14,18-6,26,42c5,34,4,42-8,42-10,0-18-14-21-37Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3448,3228c-47-72-62-118-37-118c10,0,69,109,69,127c0,20-16,15-32-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3027,3234c-8-8,18-77,31-82c15-5,16,27,2,62-9,25-21,32-33,20Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3354,3185c-19-46-4-70,19-34c21,32,25,61,9,66-7,3-19-11-28-32Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2910,3180c0-17,30-70,39-70c18,0,19,14,4,46-16,32-43,47-43,24Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3461,3128c-28-45-9-63,24-23c13,17,24,36,25,43c0,24-28,12-49-20Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2734,3119c-9-15,91-113,106-104c18,11,11,22-44,69-37,31-57,43-62,35Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2820,3118c1-20,36-58,54-58c22,0,20,10-9,43-25,29-45,35-45,15Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3535,3060c-25-26-26-30-11-36c21-8,72,38,62,55-11,17-20,14-51-19Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3607,3039c-56-40-66-52-48-63c10-6,121,71,121,84c0,22-21,16-73-21Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2734,3028c-8-12,42-58,64-58c18,0,15,21-5,37-36,28-52,33-59,21Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3613,2968c-35-21-43-38-18-38s77,30,73,42c-7,19-21,18-55-4Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2680,2927c0-15,64-49,74-40c14,14,4,30-27,41-42,15-47,15-47-1Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2604,2888c-9-14,4-22,70-42c57-17,93-11,64,11-23,18-127,42-134,31Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3661,2877c-19-7-37-18-39-26-4-11,3-13,33-8c43,7,64,22,50,36-6,5-24,4-44-2Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3124,2831c-21-9-69-61-76-81-2-7-100-25-228-43-155-23-225-36-224-45c1-7,2-19,3-27c1-20,40-19,274,4l187,19l29-29c24-23,38-29,73-29c48,0,103,28,112,58c7,20,48,32,116,32c68,1,80,8,80,51c0,50-11,54-107,40l-77-11-32,31c-34,33-92,46-130,30Zm86-36c17-9,30-19,30-24c0-11-144-29-148-18-8,18,41,55,76,56c7,1,26-6,42-14Zm225-46c4-6,4-13,1-16-6-7-548-63-596-62-19,1,44,12,140,25s234,32,305,43c72,10,133,19,137,20s10-4,13-10Zm-214-100c-28-23-84-25-101-4-13,16,4,23,75,27c51,4,55,0,26-23Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3707,2825c-60-13-87-28-69-39c12-7,123,13,137,25c20,19-12,25-68,14Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2644,2809c-9-16,15-29,54-29c31,0,45,17,20,24-42,13-68,15-74,5Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3645,2750c-11-18,3-26,44-22c56,5,57,32,2,32-22,0-43-4-46-10Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3640,2647c0-18,68-33,83-18s5,22-42,28c-32,4-41,2-41-10Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3630,2587c0-8,20-19,48-25c26-6,57-14,70-18c16-5,22-2,22,9s-18,22-52,32c-63,18-88,19-88,2Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2747,2563c-4-3-7-26-7-50c0-32,4-43,15-43c9,0,15,9,15,22c0,12,3,18,8,14c4-4,7-13,7-18c0-6,6-13,13-15c8-3,12,8,12,36c0,23,0,43,0,46s-3,5-7,5c-5,0-8-6-8-12c0-7-7-13-15-13s-15,5-15,12c0,15-10,25-18,16Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3610,2537c0-14,40-37,65-37c30,0,25,21-9,35-44,18-56,19-56,2Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2850,2521c0-5,19-12,41-16c141-24,244-128,264-268c5-29,12-46,19-44c31,10,6,123-43,198-52,79-161,138-253,139-16,0-28-4-28-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3566,2463c-12-12-6-22,30-43c35-23,51-22,41,2-6,17-62,49-71,41Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3530,2407c0-15,92-97,109-97c24,0,8,27-38,68-52,44-71,52-71,29Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3495,2370c-10-16,46-73,59-60c7,7,0,20-21,41-21,22-33,27-38,19Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M3202,2143c3-46,4-48,36-51c36-4,47,22,12,31-11,3-20,12-20,21s8,16,20,16c11,0,20,7,20,15c0,11-11,15-36,15h-35l3-47Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2182,2348c-87-19-153-123-137-215c14-88,84-154,170-161c91-7,159,27,196,100c25,48,27,133,5,176-28,55-118,114-170,111-11-1-40-5-64-11Zm147-46c46-34,65-69,69-129c3-49,0-64-20-93-35-52-83-80-136-80-115,0-199,115-157,216c21,51,42,73,90,96c47,22,117,18,154-10Z"
					transform="translate(-40 0)"
				/>
				<path
					className="F727D5C8-D16B-44F7-80F0-2C2E74C90CED"
					d="M2195,2303c-91-23-130-145-73-225c56-79,188-75,240,6c28,45,21,136-13,172-41,45-96,61-154,47Zm91-39c41-20,64-59,64-110c0-53-53-104-109-104-60,0-113,50-115,106-1,50,24,91,67,109c42,18,52,18,93-1Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M2224,2226c-9-23,0-141,11-141c6,0,11,34,13,78c2,50-1,77-8,77-6,0-13-6-16-14Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M1444,1812c-59-28-88-73-92-147-3-50,0-66,20-95c36-54,83-80,141-80c127,0,209,120,159,232-40,92-140,131-228,90Zm154-38c34-23,65-97,56-137-20-95-113-142-200-101-100,48-96,194,6,247c40,20,99,16,138-9Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M1462,1763c-66-32-83-123-34-182c23-28,36-34,78-38c43-5,54-2,82,22c66,56,62,151-10,195-40,24-72,25-116,3Zm112-41c30-28,37-59,22-97-25-60-84-72-135-29-23,19-31,34-31,58c0,80,85,120,144,68Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M1924,1811c-59-27-87-72-92-146-3-50,0-66,20-95c36-54,83-80,140-80c64,0,114,24,144,69c47,72,44,148-9,208-56,63-126,79-203,44Zm155-40c16-12,37-41,46-65c39-101-43-200-150-183-97,16-146,127-92,208c46,69,131,86,196,40Z"
					transform="translate(-39.999999 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M1944,1764c-40-19-64-62-64-113c0-118,173-153,224-46c21,44,20,73-4,112-35,58-97,77-156,47Zm110-43c30-26,38-58,22-96-26-62-89-74-137-26-80,81,29,197,115,122Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M2399,1807c-63-33-91-85-86-160c6-94,60-148,154-154c69-5,116,16,150,67c46,66,42,148-10,207-58,66-132,80-208,40Zm159-36c83-59,77-178-11-231-119-73-261,76-184,191c45,68,131,86,195,40Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M2434,1770c-36-14-74-68-74-106c0-128,170-173,224-60c21,45,20,74-4,113-32,53-93,75-146,53Zm75-31c63-22,77-107,24-149-37-29-79-26-114,9-45,45-37,105,19,135c33,19,32,18,71,5Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M2880,1806c-121-65-118-242,6-301c49-23,129-17,173,14c102,73,88,236-25,291-53,26-100,25-154-4Zm159-33c86-63,75-189-21-239-60-31-139-6-178,58-74,122,84,265,199,181Z"
					transform="translate(-40 0)"
				/>
				<path
					className="376C75E5-B966-473E-9116-E17926F265BF"
					d="M2904,1761c-63-39-81-99-49-161c41-80,169-78,211,2c53,102-66,220-162,159Zm85-22c33-12,61-52,61-89c0-33-53-80-90-80s-90,47-90,80c0,28,17,61,44,82c25,21,33,21,75,7Z"
					transform="translate(-40 0)"
				/>
				<rect
					width="404.167837"
					height="1344.136515"
					rx="0"
					ry="0"
					transform="matrix(14.948818 0 0-2.643475-797.624879 4140.811194)"
					opacity="0.2"
					strokeWidth="0"
				/>
			</g>
		</svg>
	);
}

export const MemoPlaceholderScooterOdometer = React.memo(PlaceholderScooterOdometer);
